export enum PageAtomKeys{
    preferenceCardAtom ="PreferenceCard", 
    profileDetailsAtom = "ProfileDetails",
    registrationTokenAtom = "RegistrationToken",
    configurationListAtom = 'ConfigurationList',
    jsonDataAtom='JsonData',
    pageNameAtom='PageName',
    token='token',
}

export enum AppAtomKeys{
    spinnerOverlayAtom = "SpinnerOverlay",
    commonPageAtom = "CommonPage",
}

export const AppTypeName = {
    Hybrid: "Hybrid",
    Terminal: "Terminal",
    Kiosk: "Kiosk",
    Kitchen_Display_System: "Kitchen Display System",
}